import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Custom typography role tokens (`text-card-title`, `text-form-label`, ...)
// are defined in globals.css and share the `text-*` prefix with text-colors.
// Without this extension twMerge classifies them as `text-color` and drops a
// coexisting color class (e.g. variant's `text-primary-foreground` on Button),
// so an active teal button rendered dark text instead of white.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'screen-hero-title',
            'screen-title',
            'screen-subtitle',
            'page-title',
            'plan-name-hero',
            'section-title',
            'section-subtitle',
            'section-eyebrow',
            'card-title',
            'card-body',
            'card-meta',
            'sheet-title',
            'subpanel-title',
            'form-label',
            'form-input',
            'form-help',
            'form-error',
            'list-item-title',
            'list-item-subtitle',
            'list-item-meta',
            'list-item-value',
            'chip',
            'progress-value',
            'progress-meta',
            'progress-fact',
            'token-balance',
            'price-value',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
